import { simpleGETRequest } from '@/helpers/request';

export async function fetchSinoaInsights(days = 30) {
  const data = await simpleGETRequest(`/sinoa_insights/get_insights/?days=${days}`);
  return data;
}

export async function fetchKeywordRelationships(keyword) {
  const data = await simpleGETRequest(
    `/sinoa_insights/keyword_relationships/?keyword=${encodeURIComponent(keyword)}`,
  );
  return data;
}

export async function fetchKeywordStats(keyword, days = 30) {
  const data = await simpleGETRequest(
    `/sinoa_insights/keyword_stats/?keyword=${encodeURIComponent(keyword)}&days=${days}`,
  );
  return data;
}

export async function fetchKeywordIntelligence(keyword) {
  const data = await simpleGETRequest(
    `/sinoa_insights/keyword_intelligence/?keyword=${encodeURIComponent(keyword)}`,
  );
  return data;
}

export async function fetchRelationshipExplanation(keyword, relatedEntity) {
  const data = await simpleGETRequest(
    `/sinoa_insights/relationship_explanation/?keyword=${encodeURIComponent(keyword)}&related_entity=${encodeURIComponent(relatedEntity)}`,
  );
  return data;
}
